<nz-layout class="app-layout ant-layout-has-sider">
  <nz-sider class="menu-sidebar" nzCollapsible nzWidth="256px" nzBreakpoint="xxl" [(nzCollapsed)]="isCollapsed" [nzTrigger]="null">
    <app-sidenav [isCollapsed]="isCollapsed"></app-sidenav>
  </nz-sider>

  <nz-layout class="right-layout">
    <nz-header>
      <app-header [isCollapsed]="isCollapsed" (collapse$)="isCollapsed = $event"> </app-header>
    </nz-header>
    <nz-content>
      <main class="inner-content" [@routeAnimation]="getRouteAnimationState()">
        <router-outlet class="shell-outlet"></router-outlet>
      </main>
    </nz-content>
  </nz-layout>
</nz-layout>
